<div *ngIf="showModal"
  class="overflow-x-hidden overflow-y-auto fixed inset-0 z-100 outline-none focus:outline-none justify-center items-center flex">
  <div class="relative w-[95vw] lg:w-[65vw] xl:w-[50vw] md:my-6 md:py-4 md:px-4 mx-auto">
    <div
      class="border-0 rounded-lg dark-shadow relative flex flex-col max-h-[50rem] bg-background outline-none focus:outline-none dark:bg-background-dark min-w-[50vw] max-w-[90vw] mx-auto">
      <div class="p-4 py-12 flex-grow dark:border dark:border-grey rounded">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
<div *ngIf="showModal" class="opacity-25 fixed inset-0 z-90 bg-black"></div>